'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _immutable = require('immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LandingPageDisplayRecordBase = (0, _immutable.Record)({
  title: function title() {
    return _I18n2.default.text('core.landingPage.core.title');
  },
  subtitle: function subtitle() {
    return _I18n2.default.text('core.landingPage.core.subtitle');
  },
  submitButton: function submitButton() {
    return _I18n2.default.text('core.landingPage.core.submitButton');
  },
  authedTitle: function authedTitle() {
    return _I18n2.default.text('core.landingPage.core.authedTitle');
  }, // used only in embedded signup
  startButton: function startButton() {
    return _I18n2.default.text('core.landingPage.core.startButton');
  }, // used only in embedded signup
  ContentAfterSubmit: null,
  ContentAfterForm: null,
  ContentWithDivider: null
}, 'LandingPageDisplayRecord');

var LandingPageDisplayRecord = function (_LandingPageDisplayRe) {
  _inherits(LandingPageDisplayRecord, _LandingPageDisplayRe);

  function LandingPageDisplayRecord() {
    _classCallCheck(this, LandingPageDisplayRecord);

    return _possibleConstructorReturn(this, (LandingPageDisplayRecord.__proto__ || Object.getPrototypeOf(LandingPageDisplayRecord)).apply(this, arguments));
  }

  _createClass(LandingPageDisplayRecord, [{
    key: 'get',
    value: function get(key) {
      var result = _get(LandingPageDisplayRecord.prototype.__proto__ || Object.getPrototypeOf(LandingPageDisplayRecord.prototype), 'get', this).call(this, key);
      if (key === 'title' || key === 'subtitle' || key === 'submitButton' || key === 'authedTitle' || key === 'startButton') {
        if (typeof result === 'function') {
          return result();
        }
      }
      return result;
    }
  }]);

  return LandingPageDisplayRecord;
}(LandingPageDisplayRecordBase);

exports.default = LandingPageDisplayRecord;
module.exports = exports['default'];